import {
  Component,
  OnInit,
  Input,
  input,
  InputSignal,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  inject,
} from '@angular/core';
import {
  ApexAxisChartSeries,
  ApexChart,
  ApexDataLabels,
  ApexPlotOptions,
  ApexResponsive,
  ApexXAxis,
  ApexLegend,
  ApexFill,
  ApexGrid,
  ApexStroke,
  NgApexchartsModule,
} from 'ng-apexcharts';
import { FeatureImportance } from '../../../interfaces';

type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  stroke: ApexStroke;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  responsive: ApexResponsive[];
  xaxis: ApexXAxis;
  grid: ApexGrid;

  colors: string[];
  legend: ApexLegend;
  fill: ApexFill;
};

@Component({
  selector: 'app-charts-widget12',
  templateUrl: './charts-widget12.component.html',
  standalone: true,
  imports: [NgApexchartsModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChartsWidget12Component implements OnInit {
  feautureImportance: InputSignal<FeatureImportance> = input.required();
  chartOptions: any = {};

  private cdr = inject(ChangeDetectorRef);
  constructor() {}
  ngOnInit(): void {
    //);
    this.chartOptions = {
      series: [
        {
          name: 'Positive',
          data: [
            (this.feautureImportance().monthsAsCustomer ?? 0) > 0
              ? this.feautureImportance().monthsAsCustomer
              : -0.0,
            (this.feautureImportance().insuredAge ?? 0) > 0
              ? this.feautureImportance().insuredAge
              : -0.0,
            (this.feautureImportance().policyCsl ?? 0) > 0
              ? this.feautureImportance().policyCsl
              : -0.0,
            (this.feautureImportance().policyPremium ?? 0) > 0
              ? this.feautureImportance().policyPremium
              : -0.0,
            (this.feautureImportance().insuredSex ?? 0) > 0
              ? this.feautureImportance().insuredSex
              : -0.0,
            (this.feautureImportance().insuredEducationLevel ?? 0) > 0
              ? this.feautureImportance().insuredEducationLevel
              : -0.0,
            (this.feautureImportance().insuredOccupation ?? 0) > 0
              ? this.feautureImportance().insuredOccupation
              : -0.0,
            (this.feautureImportance().insuredHobbies ?? 0) > 0
              ? this.feautureImportance().insuredHobbies
              : -0.0,
            (this.feautureImportance().insuredRelationship ?? 0) > 0
              ? this.feautureImportance().insuredRelationship
              : -0.0,
            //(this.feautureImportance().capitalLoss ?? 0) > 0 ? this.feautureImportance().capitalLoss : - 0.0,
            (this.feautureImportance().maritalStatus ?? 0) > 0
              ? this.feautureImportance().maritalStatus
              : -0.0,
            (this.feautureImportance().incidentType ?? 0) > 0
              ? this.feautureImportance().incidentType
              : -0.0,
            (this.feautureImportance().collisionType ?? 0) > 0
              ? this.feautureImportance().collisionType
              : -0.0,
            (this.feautureImportance().incidentSeverity ?? 0) > 0
              ? this.feautureImportance().incidentSeverity
              : -0.0,
            (this.feautureImportance().authoritiesContacted ?? 0) > 0
              ? this.feautureImportance().authoritiesContacted
              : -0.0,
            (this.feautureImportance().incidentState ?? 0) > 0
              ? this.feautureImportance().incidentState
              : -0.0,
            (this.feautureImportance().numberOfVehiclesInvolved ?? 0) > 0
              ? this.feautureImportance().numberOfVehiclesInvolved
              : -0.0,
            (this.feautureImportance().propertyDamage ?? 0) > 0
              ? this.feautureImportance().propertyDamage
              : -0.0,
            (this.feautureImportance().bodilyInjuries ?? 0) > 0
              ? this.feautureImportance().bodilyInjuries
              : -0.0,
            (this.feautureImportance().witnesses ?? 0) > 0
              ? this.feautureImportance().witnesses
              : -0.0,
            (this.feautureImportance().policeReportAvailable ?? 0) > 0
              ? this.feautureImportance().policeReportAvailable
              : -0.0,
            (this.feautureImportance().totalClaimAmount ?? 0) > 0
              ? this.feautureImportance().totalClaimAmount
              : -0.0,
            (this.feautureImportance().injuryClaim ?? 0) > 0
              ? this.feautureImportance().injuryClaim
              : -0.0,
            (this.feautureImportance().propertyClaim ?? 0) > 0
              ? this.feautureImportance().propertyClaim
              : -0.0,
            (this.feautureImportance().vehicleClaim ?? 0) > 0
              ? this.feautureImportance().vehicleClaim
              : -0.0,
            (this.feautureImportance().autoYear ?? 0) > 0
              ? this.feautureImportance().autoYear
              : -0.0,
          ],
        },
        {
          name: 'Negative',
          data: [
            (this.feautureImportance().monthsAsCustomer ?? 0) < 0
              ? this.feautureImportance().monthsAsCustomer
              : -0.0,
            (this.feautureImportance().insuredAge ?? 0) < 0
              ? this.feautureImportance().insuredAge
              : -0.0,
            (this.feautureImportance().policyCsl ?? 0) < 0
              ? this.feautureImportance().policyCsl
              : -0.0,
            (this.feautureImportance().policyPremium ?? 0) < 0
              ? this.feautureImportance().policyPremium
              : -0.0,
            (this.feautureImportance().insuredSex ?? 0) < 0
              ? this.feautureImportance().insuredSex
              : -0.0,
            (this.feautureImportance().insuredEducationLevel ?? 0) < 0
              ? this.feautureImportance().insuredEducationLevel
              : -0.0,
            (this.feautureImportance().insuredOccupation ?? 0) < 0
              ? this.feautureImportance().insuredOccupation
              : -0.0,
            (this.feautureImportance().insuredHobbies ?? 0) < 0
              ? this.feautureImportance().insuredHobbies
              : -0.0,
            (this.feautureImportance().insuredRelationship ?? 0) < 0
              ? this.feautureImportance().insuredRelationship
              : -0.0,
            (this.feautureImportance().maritalStatus ?? 0) < 0
              ? this.feautureImportance().maritalStatus
              : -0.0,
            (this.feautureImportance().incidentType ?? 0) < 0
              ? this.feautureImportance().incidentType
              : -0.0,
            (this.feautureImportance().collisionType ?? 0) < 0
              ? this.feautureImportance().collisionType
              : -0.0,
            (this.feautureImportance().incidentSeverity ?? 0) < 0
              ? this.feautureImportance().incidentSeverity
              : -0.0,
            (this.feautureImportance().authoritiesContacted ?? 0) < 0
              ? this.feautureImportance().authoritiesContacted
              : -0.0,
            (this.feautureImportance().incidentState ?? 0) < 0
              ? this.feautureImportance().incidentState
              : -0.0,
            (this.feautureImportance().numberOfVehiclesInvolved ?? 0) < 0
              ? this.feautureImportance().numberOfVehiclesInvolved
              : -0.0,
            (this.feautureImportance().propertyDamage ?? 0) < 0
              ? this.feautureImportance().propertyDamage
              : -0.0,
            (this.feautureImportance().bodilyInjuries ?? 0) < 0
              ? this.feautureImportance().bodilyInjuries
              : -0.0,
            (this.feautureImportance().witnesses ?? 0) < 0
              ? this.feautureImportance().witnesses
              : -0.0,
            (this.feautureImportance().policeReportAvailable ?? 0) < 0
              ? this.feautureImportance().policeReportAvailable
              : -0.0,
            (this.feautureImportance().totalClaimAmount ?? 0) < 0
              ? this.feautureImportance().totalClaimAmount
              : -0.0,
            (this.feautureImportance().injuryClaim ?? 0) < 0
              ? this.feautureImportance().injuryClaim
              : -0.0,
            (this.feautureImportance().propertyClaim ?? 0) < 0
              ? this.feautureImportance().propertyClaim
              : -0.0,
            (this.feautureImportance().vehicleClaim ?? 0) < 0
              ? this.feautureImportance().vehicleClaim
              : -0.0,
            (this.feautureImportance().autoYear ?? 0) < 0
              ? this.feautureImportance().autoYear
              : -0.0,
          ],
        },
      ],
      chart: {
        type: 'bar',
        height: 500,
        width: '100%',
        stacked: true,
      },
      colors: ['#008FFB', '#FF4560'],
      plotOptions: {
        bar: {
          horizontal: true,
          columnWidth: '70%',
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        width: 1,
        colors: ['#fff'],
      },
      xaxis: {
        categories: [
          'Months As Customer',
          'Age',
          'Policy Csl',
          'Policy Deductible',
          'Insured Sex',
          'Insured Education Level',
          'Insured Occupation',
          'Insured Hobbies',
          'Insured Relationship',
          'Marital Status',
          // 'Capital - Loss',
          // 'Incident Date',
          'Incident Type',
          'Collision Type',
          'Incident Severity',
          'Authorities Contacted',
          'Incident State',
          'Number Of Vehicles Involved',
          'Property Damage',
          'Bodily Injuries',
          'Witnesses',
          'Police Report Available',
          'Total Claim Amount',
          'Injury Claim',
          'Property Claim',
          'Vehicle Claim',
          'Auto Year',
        ],
        title: {
          text: 'Percent',
        },
      },
      tooltip: {
        y: {
          formatter: function (value: any) {
            return value.toFixed(2) + '%';
          },
        },
      },
    };
    this.cdr.markForCheck();
  }
}
